<template>
    <div class="input-item">
        <label v-if="label" class="input-item__label">{{ label }}</label>

        <div class="input-item__wrapper">
            <input
                v-bind="$attrs"
                :value="modelValue"
                class="input-item__input"
                :class="{ 'input-item--error': vMessage.length > 0 }"
                @input="$emit('update:modelValue', handleInputChange($event))"
            />
        </div>

        <span v-if="vMessage.length > 0" class="input-item__error">
            <span class="input-item__error__msg">{{ vMessage[0] }}</span>
        </span>
    </div>
</template>

<script lang="ts">
    import { defineComponent } from 'vue'

    export default defineComponent({
        props: {
            label: {
                type: String,
                default: ''
            },
            modelValue: {
                type: [String, Number],
                default: ''
            },
            vMessage: {
                type: Array,
                default: []
            }
        },
        setup() {
            const handleInputChange = (event: Event) => (event.target as HTMLInputElement).value
            return { handleInputChange }
        },
    })
</script>
